import { render, staticRenderFns } from "./VisitsByInstitution.vue?vue&type=template&id=11f1545c&"
import script from "./VisitsByInstitution.vue?vue&type=script&lang=js&"
export * from "./VisitsByInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports